import { IBaseSobFinancialData } from 'partner360/models/financialTable/baseSobFinancialData'

import {
  IFieldsToRecalculate,
  TFieldsToRecalculateMap,
} from '../../models/financialTable/fieldsToRecalculate'

import { fieldsToRecalculateQoQ, fieldsToRecalculateYoY } from './constants'

interface IGetRecalculatedYoYFields<T extends IBaseSobFinancialData> {
  item: T
}

const handleYoYAndQoQSobCalculation = <T extends IBaseSobFinancialData>(
  recalcInfo: IFieldsToRecalculate,
  field: string,
  item: T,
  fieldsToRecalculate: TFieldsToRecalculateMap
): Record<string, number> => {
  let data = calculateYoYAndQoQSob(recalcInfo, field, item)
  if (recalcInfo.additionalRecalc) {
    const additionalRecalcInfo = fieldsToRecalculate[recalcInfo.additionalRecalc]
    data = {
      ...data,
      ...calculateYoYAndQoQSob(additionalRecalcInfo, recalcInfo.additionalRecalc, item),
    }
  }

  if (recalcInfo.yearField) {
    const yearRecalcInfo = fieldsToRecalculate[recalcInfo.yearField]
    if (yearRecalcInfo) {
      data = { ...data, ...calculateYoYAndQoQSob(yearRecalcInfo, recalcInfo.yearField, item) }
    }
  }
  return data
}

const calculateYoYAndQoQSob = <T extends IBaseSobFinancialData>(
  recalcInfo: IFieldsToRecalculate,
  field: string,
  item: T
): Record<string, number> => {
  const difference = item[field] - item[recalcInfo.prevValue]

  const limitedDifference = Math.max(-100, Math.min(100, difference))

  return {
    [recalcInfo.fieldToChange]: limitedDifference,
  }
}

export const getRecalculatedYoYAndQoQFields = <T extends IBaseSobFinancialData>({
  item,
}: IGetRecalculatedYoYFields<T>): Record<string, number> => {
  const recalculatedYoYFields = Object.keys(fieldsToRecalculateYoY).reduce((acc, field) => {
    const recalcYoYInfoSob = fieldsToRecalculateYoY[field]
    if (recalcYoYInfoSob) {
      return {
        ...acc,
        ...handleYoYAndQoQSobCalculation(recalcYoYInfoSob, field, item, fieldsToRecalculateYoY),
      }
    }
    return acc
  }, {})

  const recalculatedQoQFields = Object.keys(fieldsToRecalculateYoY).reduce((acc, field) => {
    const recalcQoQInfo = fieldsToRecalculateQoQ[field]
    if (recalcQoQInfo) {
      return {
        ...acc,
        ...handleYoYAndQoQSobCalculation(recalcQoQInfo, field, item, fieldsToRecalculateQoQ),
      }
    }
    return acc
  }, {})

  return { ...recalculatedYoYFields, ...recalculatedQoQFields }
}
